import { METHODS } from '../constants';
import utils from '../utils';

const investment = () => ({
  getInvestmentIdsWithouthJointUrl: () => utils.fetch(`${process.env.HOST}/api/customer/investment-ids`),
  getInvestmentIdsUrl: () => utils.fetch(`${process.env.HOST}/api/customer/investment-ids-jointholder`),
  getInvestmentIdsCIBUrl: () => utils.fetch(`${process.env.HOST}/api/customer/investment-ids-cib`),
  getMinorStatus: () => utils.fetch(`${process.env.HOST}/api/customer/minor-status`),
  getInvestmentSummaryById: (investmentId?: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/investment-id-summary?investmentId=${investmentId}`),
  getInvestmentSummaryByIdCIB: (investmentId?: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/investment-id-summary-cib?investmentId=${investmentId}`),
  getInvestmentDetailsUrl: () => `${process.env.HOST}/api/investment-details`,
  getHoldingsUrl: (investmentId: string) =>
    `${process.env.HOST}api/customer/current-holdings?investmentId=${investmentId}`,
  // getBuyDetailsUrl: (investmentId: string, fundCode: string, folioNumber: string, lastTransactionId: string) =>
  // `${process.env.HOST}/api/transaction/buy/details?fundCode=${fundCode}&investmentId=${investmentId}&folioNumber=${folioNumber}&transactionId=${lastTransactionId}`,
  getBuyDetailsUrl: (investmentId: string, fundCode: string | string[], folioNumber: string) =>
    `${process.env.HOST}/api/transaction/buy/details?fundCode=${fundCode}&investmentId=${investmentId}&folioNumber=${folioNumber}`,
  getBuyBankDetails: (investmentId: string) =>
    `${process.env.HOST}/api/transaction/buy/bank-account-for-investment?investmentId=${investmentId}`,
  getBuyOneTimeOtp: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/buy/one-time/otp`, { data: data, method: METHODS.POST }),
  getBuyOneTimeOtpVerify: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/buy/one-time/otp/verify`, { data: data, method: METHODS.POST }),
  getBuySipOtp: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/buy/sip/otp`, { data: data, method: METHODS.POST }),
  getBuySipOtpVerify: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/buy/sip/otp/verify`, { data: data, method: METHODS.POST }),
  getRelationShipCodes: () => utils.fetch(`${process.env.HOST}/api/transaction/buy/relationship-codes`),
  getSwitchOutDetailsUrl: (investmentId: string, fundCode: string, folioNumber: string) =>
    `${process.env.HOST}/api/transaction/switch/switch-out-details?investmentId=${investmentId}&fundCode=${fundCode}&folioNumber=${folioNumber}`,
  getSwitchInFoliosUrl: (investmentId: string, fundCode: string) =>
    `${process.env.HOST}/api/transaction/switch/switch-in/folio?fundCode=${fundCode}&investmentId=${investmentId}`,
  getSwitchInDetailsUrl: (
    investmentId: string,
    fromFundCode: string,
    toFundCode: string,
    toFolioNumber: string,
    fromFolioNumber: string
  ) =>
    `${process.env.HOST}/api/transaction/switch/switch-out?fromFundCode=${fromFundCode}&investmentId=${investmentId}&toFundCode=${toFundCode}&fromFolioNumber=${fromFolioNumber}&toFolioNumber=${toFolioNumber}`,
  getSwitchOtp: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/switch/otp`, { data: data, method: METHODS.POST }),
  getSwitchOtpVerify: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/switch/otp/verify`, { data: data, method: METHODS.POST }),
  getSwitchStpOtp: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/switch/stp/otp`, { data: data, method: METHODS.POST }),
  getSwitchStpOtpVerify: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/switch/stp/otp/verify`, { data: data, method: METHODS.POST }),
  getRedeemDetailsUrl: (investmentId: string, fundCode: string, folioNumber: string) =>
    `${process.env.HOST}/api/transaction/redeem/details?fundCode=${fundCode}&investmentId=${investmentId}&folioNumber=${folioNumber}`,
  getRedeemOtp: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/redeem/otp`, { data: data, method: METHODS.POST }),
  getRedeemOtpVerify: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/redeem/otp/verify`, { data: data, method: METHODS.POST }),
  getRedeemSWPOtp: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/redeem/swp/otp`, { data: data, method: METHODS.POST }),
  getRedeemSWPOtpVerify: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/redeem/swp/otp/verify`, { data: data, method: METHODS.POST }),
    getNomineeValidate: (data) =>
    utils.fetch(`${process.env.HOST}/api/transaction/buy/nominee-validate`, { data: data, method: METHODS.POST }),

});

export default investment;
